
import {
    Text
} from '@components/1-atoms';
import ListItem from '@components/2-molecules/ListItem';
import setTheme from '@lib/theme';
import React, { FC } from 'react';

import { View } from 'react-native';

import { PageProps } from '@lib/constants';

type Props = PageProps;

const theme = setTheme('light');

const ChartOfAccountsMenu: FC<Props> = ({ navigation, onDone, ...props }) => {

    return (
        <View>
            <ListItem
                /* right={ <Forward />} */
                sub={<Text small color={"#808080"}>{"Define your chart of accounts to categorize  every single transaction"}</Text>}
                onPress={() => navigation?.navigate('AccountCreate', { ...props, onDone })}
            >
                <Text>Create an account</Text>
            </ListItem>
        </View>
    );
};

export default ChartOfAccountsMenu;